import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { ApprovalListType } from "../../../redux/hrms/hrmsTypes";
import Select from "react-select";
import { components } from "react-select";
import { CircularAvatar } from "../../commons";
import { RootState } from "../../../redux/rootReducers";
import { connect } from "react-redux";
import useDebounce from "../../../customHooks/useDebounce";
import { GetAllFinacUserPayloadType } from "../../../commonTypes/authTypes";
import { getAllFinacUsersAction } from "../../../redux/auth";
import { addApprovalAction } from "../../../redux/hrms";
import { AddApprovalPayloadType } from "../../../commonTypes/hrmsTypes";
type AppProps = {
  isOpen: boolean;
  setSendApprovalsModal: React.Dispatch<React.SetStateAction<boolean>>;
  data: ApprovalListType[] | [];
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) => void;
  dispatchSendApprovalAction: (data: AddApprovalPayloadType) => void;
  token: string | null;
  totalUserCount: number | string;
  userFetching: boolean;
  finacUser: any;
  id: string;
  handleApproval: () => void;
};

const SendApprovalModal = ({
  isOpen,
  setSendApprovalsModal,
  data,
  dispatchGetAllFinacUsersAction,
  token,
  finacUser,
  totalUserCount,
  userFetching,
  id,
  dispatchSendApprovalAction,
  handleApproval,
}: AppProps) => {
  const [userOffset, setUserOffset] = useState(0);
  const [limit, setLimit] = useState(20);
  const [userText, setUserText] = useState("");
  const [finalUserList, setFinalUserList] = useState<any>([]);
  const [selectUser, setSelectUser] = useState({
    label: "select...",
    value: null,
  });
  useEffect(() => {
    if (token) {
      let finalUserData = {
        token,
        offset: userOffset,
        limit,
        user_type: "stco_users",
        status: 1,
        search_term: userText,
      };
      if (userOffset <= +totalUserCount) {
        dispatchGetAllFinacUsersAction(finalUserData);
      }
    }
  }, [userOffset]);

  const Option = (props: any) => {
    const { data } = props;
    return (
      <components.Option {...props}>
        <div
          className="d-flex justify-content-sm-start"
          style={{ gap: "10px" }}
        >
          <CircularAvatar
            name={data?.label.split("%")[0]}
            image={data?.image && data?.image}
          />
          <div style={{ marginTop: "-3px" }}>
            <span style={{ fontWeight: "500", fontSize: "16px" }}>
              {data?.label.split("%")[0]}
            </span>
            <br></br>
            <span style={{ color: "#6e7491" }}>
              {data?.label.split("%")[1]}
            </span>
          </div>
        </div>
      </components.Option>
    );
  };
  const fetchData = (search: string) => {
    const finalData = {
      token,
      offset: userOffset,
      limit,
      user_type: "stco_users",
      status: 1,
      search_term: userText,
    };
    dispatchGetAllFinacUsersAction(finalData);
  };

  useDebounce(
    () => {
      if (userText) {
        fetchData(userText);
      } else {
        const finalData = {
          token,
          offset: userOffset,
          limit,
          user_type: "stco_users",
          status: 1,
          search_term: userText,
        };
        dispatchGetAllFinacUsersAction(finalData);
      }
    },
    500,
    [userText]
  );

  useEffect(() => {
    const finalUserData = finacUser?.data?.map((user: any) => {
      return {
        value: user?.user_id,
        label: `${user?.first_name ? user?.first_name : ""} ${
          user?.last_name ? user?.last_name : ""
        }%${user?.job_title ? user?.job_title : ""} ${
          user?.department ? "|" : ""
        } ${user?.department !== null ? user?.department : ""}`,
        image: user?.profile_pic?.file_url,
      };
    });
    if (userOffset > 0) {
      setFinalUserList([...finalUserList, ...finalUserData]);
    } else {
      setFinalUserList(finalUserData);
    }
  }, [finacUser]);

  const checkBottom = (e: any) => {
    setUserOffset((prv: any) => prv + limit);
  };

  const handleChangeUser = (data: any) => {
    setSelectUser({
      value: data?.value,
      label: data?.label?.split("%")[0],
    });
  };

  const handleSubmit = () => {
    const finalData = {
      approved_by: selectUser?.value,
      hrms_id: id,
      token,
    };
    if (selectUser?.value) {
      dispatchSendApprovalAction(finalData);
    }
    handleApproval();
  };
  return (
    <>
      <Modal
        isOpen={isOpen}
        toggle={() => setSendApprovalsModal(!isOpen)}
        // size="sm"
        style={{ maxWidth: "408px" }}
      >
        <ModalHeader
          id="cross-cut"
          toggle={() => setSendApprovalsModal(!isOpen)}
          className="p-3"
        >
          Send Level 0{data?.length + 1} Approval
        </ModalHeader>
        <ModalBody className="p-3">
          Select user below in dropdown to send interview approval request
          <div className="col-md-8 p-0 mt-4">
            <label className="mb-1" htmlFor="phoneScreener">
              Select User
            </label>
            <Select
              value={selectUser}
              options={finalUserList}
              components={{ Option }}
              onChange={
                (e) => {
                  handleChangeUser(e);
                }
                // handleInterviewFormDetailsChange("phoneScreener", e)
              }
              isSearchable={true}
              isLoading={userFetching}
              onMenuClose={() => {
                setUserOffset(0);
              }}
              onMenuScrollToBottom={(e: any) => checkBottom(e)}
              // isDisabled={isDisabled}
              onInputChange={(e) => {
                setUserText(e);
                setUserOffset(0);
              }}
            />
          </div>
          <div className="row " style={{ marginTop: "80px" }}>
            <div className="col-md-12 d-flex justify-content-between">
              <button
                className="btn"
                style={{ border: "1px solid #bfcbe1", marginRight: "15px" }}
                onClick={() => setSendApprovalsModal(!isOpen)}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={handleSubmit}
                disabled={!selectUser?.value}
              >
                Send for Level 0{data?.length + 1} Approval
              </button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};
const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  finacUser: state.auth.finacUsersList,
  totalUserCount: state.auth.totalUserCount,
  userFetching: state.auth.fetching,
});
const dispatchStateToProps = (dispatch: any) => ({
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) =>
    dispatch(getAllFinacUsersAction(data)),
  dispatchSendApprovalAction: (data: AddApprovalPayloadType) => {
    dispatch(addApprovalAction(data));
  },
});

export default connect(
  mapStateToProps,
  dispatchStateToProps
)(SendApprovalModal);

// export default SendApprovalModal;
